import React from "react"


let SplitterSymbol = () => (<span className="splitter-symbol"> / </span>)


export default SplitterSymbol;